export enum LOYALTIES {
  SPOONITY = 'spoonity',
  COMO = 'comoMX',
  LOYALSENSE = 'loyalsenseMX',
  PAYBACK = 'paybackMX'
}
